import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';

const ExpiredRedirectionCard = () => {
	const [timer, setTimer] = useState(5);

	useEffect(() => {
		const interval = setInterval(() => {
			setTimer((prevTimer) => {
				if (prevTimer <= 1) {
					clearInterval(interval);
					handleRedirect();
					return 0;
				}
				return prevTimer - 1;
			});
		}, 1000);

		return () => clearInterval(interval);
	}, []);

	const handleRedirect = async () => {
		if (global.encryptedres && global.resDate && global.encryptedFiId) {
			if (global.redirectUrl?.includes('?')) {
				window.location.replace(
					global.redirectUrl +
						'&ecres=' +
						global.encryptedres +
						'&resdate=' +
						global.resDate +
						'&fi=' +
						global.encryptedFiId
				);
			} else {
				window.location.replace(
					global.redirectUrl +
						'?ecres=' +
						global.encryptedres +
						'&resdate=' +
						global.resDate +
						'&fi=' +
						global.encryptedFiId
				);
			}
		} else {
			window.location.replace(global.redirectUrl);
		}
	};

	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
			}}
		>
			<Typography>You will be redirected in {timer} ...</Typography>
		</Box>
	);
};

export default ExpiredRedirectionCard;
